import React, { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

function ExpandableText({ text, className = "", maxLength = 42, emptyText = "-" }) {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();
  const value = String(text || emptyText);
  const isLong = value.length > maxLength;
  const visible = !isLong || open ? value : `${value.slice(0, maxLength).trim()}...`;

  return (
    <button
      type="button"
      className={`expandableText ${open ? "open" : ""} ${className}`}
      onClick={() => isLong && setOpen((v) => !v)}
      title={isLong ? (open ? t("common.close") : t("common.showAll")) : value}
    >
      <span>{visible}</span>
      {isLong && <small>{open ? t("common.showLess") : t("common.showMore")}</small>}
    </button>
  );
}

export default ExpandableText;
